import cx from 'classnames';
import { ReactNode } from 'react';

interface FieldDetailListProps {
  // default is 4, supports 1-4
  columns?: number;
  condensed?: boolean;
  children: ReactNode;
}

export default function FieldDetailList({
  columns = 4,
  condensed,
  children,
}: FieldDetailListProps): JSX.Element {
  return (
    <dl
      className={cx('inline-grid gap-y-6 w-full', condensed ? 'gap-x-8' : 'gap-x-16', {
        'grid-cols-1': columns === 1,
        'grid-cols-2': columns === 2,
        'grid-cols-3': columns === 3,
        'grid-cols-3 md:grid-cols-4': columns === 4,
      })}
    >
      {children}
    </dl>
  );
}
